import { createFileRoute } from '@tanstack/react-router'
import { DownloadLinksPage } from '~/features/admin/download-links-page'

export const Route = createFileRoute('/admin/download-links')({
  component: DownloadLinksPage,
})
